import {Component, Input, OnInit} from '@angular/core';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {DocumentModel} from 'src/app/models/document.model';
import {InvoicepaymentService} from 'src/app/services/invoicepayment.service';
import {PaymentTypeModel} from 'src/app/models/payment-type.model';
import {NominalModel} from 'src/app/models/nominal.model';
import {DepositBeanModel} from 'src/app/models/deposit-bean.model';
import {CurrencyModel} from 'src/app/models/currency.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {DocumentTypes} from '../../definitions/document-types';
import {TestConnectionService} from '../../services/test-connection.service';
import {GeneralService} from '../../services/general.service';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.page.html',
    styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {

    @Input() document: DocumentModel;
    paymentMethods: PaymentTypeModel[];
    expiryMonths: string[];
    cashAccounts: NominalModel[];
    depositTemp: DepositBeanModel;
    configuration: ConfigurationModel;
    loadingOverlay: any;

    constructor(public modalController: ModalController,
                private invoicePaymentService: InvoicepaymentService,
                private alertController: AlertController,
                private loki: LokijsService,
                private configService: ConfigurationService,
                private docTypes: DocumentTypes,
                private testConnection: TestConnectionService,
                private generalService: GeneralService,
                private loadingController: LoadingController) {
    }

    async ionViewWillEnter() {
    }

    async ngOnInit() {
        this.depositTemp = JSON.parse(JSON.stringify(this.document.deposit));
        this.configuration = await this.configService.getConfiguration();
        if (!this.depositTemp.amount) {
            await this.initDepositBean();
        }
        // this.calculateDueAmount();
        this.expiryMonths = await this.invoicePaymentService.getExpiryDates();
        this.paymentMethods = await this.loki.getCollection('paymentmethods').chain().data() as PaymentTypeModel[]; //  this.invoicePaymentService.getPaymentMethods()
        this.cashAccounts = await this.loki.getCollection('cashaccounts').chain().data() as NominalModel[]; // await this.loki.getCollection('cashaccounts').chain().data();
    }

    calculateDueAmount() {
        this.depositTemp.amountDue = 0;
        for (const line of this.document.detailLines) {
            // Todo : inc vat , its a hack we need to handle vat on services which is 13.5 ,and need to
            if (line.plu) {
                this.depositTemp.amountDue += line.total * 1.23;
            }
        }
    }

    calculateChange() {
        this.depositTemp.change = this.depositTemp.amount - this.depositTemp.amountDue;
        if (this.depositTemp.change < 0 || this.depositTemp.amountDue === 0) {
            this.depositTemp.change = 0;
        }
    }


    async selectDate() {
        const alert = await this.alertController.create({
            header: 'Select Date',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'date',
                    type: 'date',
                    value: this.generateDate()
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        console.log(data);
                        this.depositTemp.date = this.formDate(data.date);
                    }
                }
            ]
        });
        await alert.present();
    }

    generateDate() {
        return this.depositTemp.date.substr(0, 10);
    }

    formDate(date: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);

        return resDate.toISOString();
    }

    changeCashAccountOrPayment(c1: any, c2: any): boolean {
        return c1 && c2 ? c1.cod === c2.cod : c1 === c2;
    }

    async initDepositBean() {
        this.depositTemp.amountDue = 0;
        this.depositTemp.change = 0;
        this.depositTemp.amount = 0;
        this.depositTemp.date = new Date().toISOString();
        // By definition the default payment method is Cash/Cheque
        this.depositTemp.type = await this.loki.getCollection('paymentmethods').chain().find({cod: 'C'}).data()[0];
        this.depositTemp.cashAccount = await this.loki.getCollection('cashaccounts').chain()
            .find({cod: this.configuration.selectedCashAccount}).data()[0];
        if (!this.depositTemp.cashAccount) {
            this.depositTemp.cashAccount = await this.loki.getCollection('cashaccounts').chain().data()[0];
        }
        console.log(this.depositTemp.cashAccount);
        this.depositTemp.cashAccount.currencyId = new CurrencyModel();
    }

    savePayment() {
        // this.changePaymentType();
        // this.changeCashAccount();

        this.document.deposit = JSON.parse(JSON.stringify(this.depositTemp));

        this.modalController.dismiss();
    }

    updateAmountPaid() {
        if (this.depositTemp.amount === 0) {
            this.depositTemp.amount = this.depositTemp.amountDue;
        }
    }

    async loadingOverlaySpinner() {
        await this.loadingController.create({
            message: 'Loading...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loadingOverlay = overlay;
            this.loadingOverlay.present();
        });
    }

    fetchPayment() {
        // TODO fetch the value in the backend
        this.loadingOverlaySpinner().then(() => {
            this.testConnection.pingServer().then(() => {
                // this.depositTemp.amountDue = 100;
                this.loadingOverlay.dismiss();
            }).catch(() => {
                this.generalService.createToast('No Connection to the server');
                this.loadingOverlay.dismiss();
            });
        });
    }
}
